import { Component } from "react";
import inhand from '../../../img/inhand.png'
import store from '../../../img/store.png'
import money from '../../../img/money.png'
import { Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import { useEffect } from 'react';
// import { API_URL } from "../../constant/API_Settings";
import { useState } from 'react';
import FuelLoginHeaderOperational from './FuelLoginHeader.component';
import Sidebar_Progress from "../../layouts/Operational_Sidebar_Progress.component";
import FuelTabHeader from "./FuelTabHeader.Component";
import { API_URL } from '../../../constant/API_Settings';
import PaginationComponent from '../../layouts/PaginationComponent';
import { preventNonNumericalInput } from '../../layouts/Operational_Sidebar_Progress.component'
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import Modal from "react-modal";
import { validateOperationalDateRange } from '../../../utils/operationalListFilters';

const SHOW_ROW_OPTIONS = [20, 50, 100, 200, 300, 400, 500];

const formatQuantityDelta = (value) => {
	const n = Number(value);
	if (!Number.isFinite(n) || n === 0) {
		return { text: '0.00', className: 'text-muted' };
	}
	const abs = Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	if (n > 0) {
		return { text: `+${abs}`, className: 'text-success fw-semibold' };
	}
	return { text: `-${abs}`, className: 'text-danger fw-semibold' };
};

const  PaginationComp  = (props) => (
	< PaginationComponent  {...props} />
		 );
const TankModalView = (obj) => {
   const [list_data1, setList1] = useState([])
   const [from_date, setFromDate] = useState('')
   const [to_date, setToDate] = useState('')
   const [created_from, setCreatedFrom] = useState('')
   const [created_to, setCreatedTo] = useState('')
   const [pagination_limit, setPaginationLimit] = useState(20)
	const [pages, setpages] = useState(
		{
			current_page: 1,
			last_page: 0,
			total_pages: 0,
			pagination_item: [],
			total_pages: 0,
		})
    console.log(obj)
    useEffect(() => {
        getView(obj.location.id,pages.current_page, from_date, to_date, created_from, created_to, pagination_limit)
        }, []);
    function getView(id,page, fromDate = '', toDate = '', createdFrom = '', createdTo = '', showRows = pagination_limit) {
     
        const requestOptions = {
           method: 'POST',
           headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
              "Accept": "application/json"
           },
           body: JSON.stringify({
              tank_id:id,
              from_date: fromDate,
              to_date: toDate,
              created_from: createdFrom,
              created_to: createdTo,
              pagination_limit: showRows
           })
        };
        fetch(`${API_URL}/get_tank_history?page=${page}`, requestOptions)

           .then(response => {
              return response.json();
           })
           .then(responseData => {
              if (responseData.status === false) {
                 swal("", responseData.message || "Unable to load tank history", "warning")
                 return responseData;
              }
              setList1(responseData.data || [])
              setpages({
					...pages,
					current_page: responseData.current_page,
					last_page: responseData.last_page,
					per_pages:  responseData.per_page,
					total_pages:responseData.total,
				   
				  })
              return responseData;
           })
           .catch(e => {
               
           });
     }
     const handlePagination = (number) => {
      setpages({
         ...pages,
         current_page: number        //---pagination---//
      }
      )

      getView(obj.location.id,number, from_date, to_date, created_from, created_to, pagination_limit)
   }

   const handleDateChange = (e) => {
      if(e.target.name === 'from_date') {
         setFromDate(e.target.value)
      } else if(e.target.name === 'to_date') {
         setToDate(e.target.value)
      } else if(e.target.name === 'created_from') {
         setCreatedFrom(e.target.value)
      } else if(e.target.name === 'created_to') {
         setCreatedTo(e.target.value)
      }
   }

   const handleShowChange = (e) => {
      const nextLimit = Number(e.target.value)
      setPaginationLimit(nextLimit)
      setpages({
         ...pages,
         current_page: 1
      })
      getView(obj.location.id, 1, from_date, to_date, created_from, created_to, nextLimit)
   }

   const handleSubmit = (e) => {
      e.preventDefault()
      if (!validateOperationalDateRange(from_date, to_date)) {
         return
      }
      if (!validateOperationalDateRange(created_from, created_to)) {
         return
      }
      setpages({
         ...pages,
         current_page: 1
      })
      getView(obj.location.id, 1, from_date, to_date, created_from, created_to, pagination_limit)
   }

   const handleReset = (e) => {
      e.preventDefault()
      setFromDate('')
      setToDate('')
      setCreatedFrom('')
      setCreatedTo('')
      setPaginationLimit(20)
      setpages({
         ...pages,
         current_page: 1
      })
      getView(obj.location.id, 1, '', '', '', '', 20)
   }
        return(
            <>
            <div className="main-container page-wrap">
            <div className="d-md-flex">
                <Sidebar_Progress props={obj.location.props} progress={7} />
                <div className="content-area ">
                    <FuelLoginHeaderOperational  props={obj.location.props}page_title="" />
           
            <div className="container pb-3 tab-view">
          
               <div class="row">
								<div className="col-md-12 px-4 mt-3">
               <Link to="/op-tank-edit">
								<a href="#" className="float-end btn btn-gray">Back</a>
									</Link>
                           </div></div>
                           <div className="row mt-md-5 mt-3 form-container px-4 ">
                  <div className="col-md-12">
							
                     <div class="form-wrap ">
                        <div class="tab-content" >
                             <div class="tab-pane fade show active" >
                              <div class="">
                                 <div class="row mb-3">
                                    <div class="col-md">
                                       <div class="row">
                                          <div class="col-md-2 col pl-0">
                                             <h3 class="table-title">Tank History</h3>
                                          </div>
                                         
                                       </div>
                                    </div>
                                   
                                 </div>
                                 <div class="row mb-3">
                                    <div class="col-md-3">
                                       <label for="from_date">From Date:</label>
                                       <input 
                                          type="date" 
                                          class="form-control" 
                                          id="from_date" 
                                          name="from_date" 
                                          value={from_date}
                                          onChange={handleDateChange}
                                       />
                                    </div>
                                    <div class="col-md-3">
                                       <label for="to_date">To Date:</label>
                                       <input 
                                          type="date" 
                                          class="form-control" 
                                          id="to_date" 
                                          name="to_date" 
                                          min={from_date || undefined}
                                          value={to_date}
                                          onChange={handleDateChange}
                                       />
                                    </div>
                                    <div class="col-md-3">
                                       <label for="created_from">Created From:</label>
                                       <input 
                                          type="date" 
                                          class="form-control" 
                                          id="created_from" 
                                          name="created_from" 
                                          value={created_from}
                                          onChange={handleDateChange}
                                       />
                                    </div>
                                    <div class="col-md-3">
                                       <label for="created_to">Created To:</label>
                                       <input 
                                          type="date" 
                                          class="form-control" 
                                          id="created_to" 
                                          name="created_to" 
                                          min={created_from || undefined}
                                          value={created_to}
                                          onChange={handleDateChange}
                                       />
                                    </div>
                                 </div>
                                 <div class="row mb-3">
                                    <div class="col-md-2">
                                       <label for="pagination_limit">Show</label>
                                       <select
                                          class="form-control"
                                          id="pagination_limit"
                                          name="pagination_limit"
                                          value={pagination_limit}
                                          onChange={handleShowChange}
                                       >
                                          {SHOW_ROW_OPTIONS.map((size) => (
                                             <option key={size} value={size}>{size}</option>
                                          ))}
                                       </select>
                                    </div>
                                    <div class="col-md-3 d-flex align-items-end">
                                       <button 
                                          type="button" 
                                          class="btn btn-primary me-2" 
                                          onClick={handleSubmit}
                                       >
                                          Submit
                                       </button>
                                       <button 
                                          type="button" 
                                          class="btn btn-secondary" 
                                          onClick={handleReset}
                                       >
                                          Reset
                                       </button>
                                    </div>
                                 </div>
                                 <div class="table-widget">
                                    <table class="table border">
                                       <thead>
                                          <tr>
                                             <th>ID</th>
                                             <th>Tank Name</th>
                                             <th>Date</th>
                                             <th>Operation </th>
                                             <th>From Screen </th>
                                             <th>Capacity</th>
                                             <th>Last PP</th>
                                             <th>Quantity</th>
                                             <th>Current Stock</th>
                                             <th>Stock Value</th>
                                             <th>Created At</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                       {list_data1.map(obj => {
                                          const quantityDelta = formatQuantityDelta(obj.quantity);
                                          return (
                                          <tr key={obj.id}>
                                             <td>{obj.id}</td>
                                             <td>{obj.tank_name}</td>
                                             <td>{obj.op_date}</td>
                                             <td>{obj.operation}</td>
                                             <td>{obj.from_screen}</td>
                                             <td>{obj.capacity}</td>
                                             <td>{obj?.last_purchase_price}</td>
                                             <td className={quantityDelta.className}>{quantityDelta.text}</td>
                                             <td>{obj.current_stock}</td>
                                             <td>{obj.stock_value}</td>
                                             <td>{obj.created_at}</td>
                                        </tr>
                                          );
                                        })} 
                                       </tbody>
                                    </table>
                                 <PaginationComp
										pages={pages}
										handlePagination={handlePagination}
										/>
                                 </div>
                                 <div>
                                  
                                 </div>
                                 
                              </div>
                           </div>
                        </div>
                     </div>
                    
                     
                     </div>
                     </div>
                     </div>
          </div>
          </div>
          </div>
          
			{/* {isShowing ? (<NozzleModal
				isShowing={isShowing}
				hide={toggle}
            double={double}
            preventNonNumericalInput={preventNonNumericalInput}
				dropdownData={dropdownData}
				handleInput={handleInput}
				handleSubmit={handleSubmit}
				inputValues={inputValues}
				errors={errors}
			
			/>) : null
			} */}
         {/* <Modal
              isOpen={isOpen}
              onRequestClose={toggleModal}
              contentLabel="My dialog"
              className="mymodal custommodal"
              overlayClassName="myoverlay"
            >
              <div class="modal-content">
                <div class="modal-title modal-header"><h5 class="modal-title" id="exampleModalLongTitle">Nozzle</h5><button type="button" onClick={toggleModal} class="btn-close" data-dismiss="modal" aria-label="Close"></button></div>
                <div class=" modal-body  modal-body"><p>Are you sure you want to delete this Nozzle</p></div>
                <div class="justify-content-end  modal-footer"><div class="d-flex">
                  <button type="button" class="btn btn-secondary me-2" onClick={toggleModal}>No</button>
                 {double == true ? <button type="submit" class="btn btn-primary" onClick={deleteNozzle}>Yes</button>:<button type="submit" class="btn btn-primary" disabled onClick={deleteNozzle}>Yes</button>}
                </div>
                </div>
              </div>




            </Modal> */}
          </>
        )
    }


export default TankModalView;
	
